import { render, staticRenderFns } from "./BeefPolicyTypeModal.vue?vue&type=template&id=10d8ff4d"
import script from "./BeefPolicyTypeModal.vue?vue&type=script&lang=js"
export * from "./BeefPolicyTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports